import type { VideoMimeTypes } from "@biom3/react";

export class VideoUrl {
  public readonly url: URL;
  public readonly mimeType?: VideoMimeTypes;

  constructor(urlStr: string) {
    const url = new URL(urlStr);
    this.url = url;

    if (this.isYoutubeVideo()) {
      return;
    }

    const mimeType = this.getMimeTypeFromExtension(url);
    if (!mimeType) {
      console.error("Invalid video URL", urlStr);
      throw new Error("Invalid video URL");
    }
    this.mimeType = mimeType;
  }

  getMimeTypeFromExtension(url: URL): VideoMimeTypes | undefined {
    if (!url) {
      return;
    }
    // Create a mapping of file extensions to MIME types
    const mimeTypes: { [key: string]: VideoMimeTypes } = {
      mp4: "video/mp4",
      webm: "video/webm",
      m3u8: "application/vnd.apple.mpegurl",
    };

    // Extract file extension from the URL (case insensitive)
    const fileExtension = url.pathname.split(".").pop();

    if (!fileExtension) {
      return;
    }

    // Check if the extension is in the mimeTypes object
    return mimeTypes[fileExtension.toLowerCase()];
  }

  isYoutubeVideo(): boolean {
    const allowedYoutubeHosts = [
      "www.youtube.com",
      "youtube.com",
      "youtu.be",
      "m.youtube.com",
    ];
    return allowedYoutubeHosts.includes(this.url.host);
  }
}
